export const hebrewDays: string[] = [
  'ראשון',
  'שני',
  'שלישי',
  'רביעי',
  'חמישי',
  'שישי',
  'שבת'
];

export const hebrewDaysInitials: string[] = [
  'א',
  'ב',
  'ג',
  'ד',
  'ה',
  'ו',
  'ש'
];
